<template>
  <el-row 
    v-if="video"
    class="mx-5"
  >
    <el-col :span="12">
      {{ video.title }}
      <div class="mr-2">
        <div
          class="embed-responsive embed-responsive-16by9"
          :style="`margin-top: 18px;height: ${playerHeight}px;`"
        >
          <script 
            v-if="video.videohub_content"
            ref="player"
            :data-videohub-id="video.videohub_content" 
            :src="`https://evolucional.videohub.com.br/embed.js?${now}`" 
            type="module"
          />
          <iframe
            v-else
            :src="video.content"
            :title="video.title"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          />
        </div>
      </div>
    </el-col>
    <el-col :span="12">
      <div class="d-flex w-100 justify-content-around">
        <div
          class="pointer-on-hover w-100 text-center p-2 text-primary border font-weight-bold"
          :class="{
            'bg-primary text-white border-primary': contentTab == 'transcription',
            'border-primary text-primary': video.transcription && contentTab != 'transcription',
            'border-gray text-gray': video && !video.transcription && contentTab != 'transcription',
          }"
          @click="contentTab = 'transcription'"
        >
          Transcrição
        </div>
        <div
          class="pointer-on-hover w-100 text-center p-2 text-primary border font-weight-bold"
          :class="{
            'bg-primary text-white': contentTab == 'chapters',
            'border-primary text-primary': video.chapters && contentTab != 'chapters',
            'border-gray text-gray': !video.chapters && contentTab != 'chapters',
          }"
          @click="contentTab = 'chapters'"
        >
          Capítulos
        </div>
        <div
          class="pointer-on-hover w-100 text-center p-2 text-primary border font-weight-bold"
          :class="{
            'bg-primary text-white': contentTab == 'subtopics',
            'border-primary text-primary': video.subtopics && contentTab != 'subtopics',
            'border-gray text-gray': !video.subtopics && contentTab != 'subtopics',
          }"
          @click="contentTab = 'subtopics'"
        >
          Subtópicos
        </div>
        <div
          class="pointer-on-hover w-100 text-center p-2 text-primary border font-weight-bold"
          :class="{
            'bg-primary text-white': contentTab == 'summary',
            'border-primary text-primary': video.summary && contentTab != 'summary',
            'border-gray text-gray': !video.summary && contentTab != 'summary',
          }"
          @click="contentTab = 'summary'"
        >
          Resumo  
        </div>
        <div
          class="pointer-on-hover w-100 text-center p-2 text-primary border font-weight-bold"
          :class="{
            'bg-primary text-white': contentTab == 'questions',
            'border-primary text-primary': video.questions && contentTab != 'questions',
            'border-gray text-gray': !video.questions && contentTab != 'questions',
          }"
          @click="contentTab = 'questions'"
        >
          Questões
        </div>
      </div>
      <div
        :style="`height: ${playerHeight}px; overflow-y: auto;`"
        class="border p-3"
      >
        <div
          v-if="video[contentTab]"
          style="white-space: pre-line;"
          v-html="video[contentTab]"
        />
        <span v-else>
          O vídeo selecionado não possui {{ {
            "transcription": "transcrição",
            "chapters": "capítulos",  
            "subtopics": "subtópicos",
            "summary": "resumo",
            "questions": "questões"
          }[contentTab] || 'conteúdo'
          }}.
        </span>
      </div>
    </el-col>
  </el-row>
</template>
<script>
export default {
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      now: Date.now(),
      contentTab: 'transcription',
      playerHeight: 600,
    }
  },
  mounted() {
    if (window.innerHeight >= 900) {
      this.playerHeight = 800;
    }
  }
}
</script>